export class AnimatedForm {
    public static startAnimatedForm() {
        $('.container__animated-form--preview').hide();

        const unfoldScrolldAct = Array.from($('.act-0'));
        const loginFingerAct = Array.from($('.act-1'));
        const passwordFingerAct = Array.from($('.act-2'));
        const playFingerAct = Array.from($('.act-3'));
        const giveMeMyMoneyAct = Array.from($('.act-4'));
        
        AnimatedForm.showAct(unfoldScrolldAct, 0);

        const totalTimeAwait = AnimatedForm.getAnimationTimeAwait(unfoldScrolldAct[0]);
        $('.vertical-middle-absolute-video-preloader').delay(totalTimeAwait / 2)
            .fadeIn(totalTimeAwait / 2);

        setTimeout(()=>{
            unfoldScrolldAct[unfoldScrolldAct.length - 1].style.setProperty('visibility', 'hidden');
            AnimatedForm.showAct(loginFingerAct, 1, true);
            
            document.querySelector('#registration [name=email]').addEventListener('keypress', () => {
                AnimatedForm.showAct(passwordFingerAct, 2, true);
                loginFingerAct[loginFingerAct.length - 1].style.setProperty('visibility', 'hidden');

                document.querySelector('#registration [name=password]').addEventListener('keypress', () => {
                    AnimatedForm.showAct(playFingerAct, 3, true);
                    passwordFingerAct[passwordFingerAct.length - 1].style.setProperty('visibility', 'hidden');

                    const submitBtn = document.querySelector('#registration [type=submit]');
                    submitBtn.addEventListener('click', () => {
                        if (window.app.registrationV124beforeSend(document.querySelector('#registration [type=submit]'))) {
                            const totalTimeAwait = AnimatedForm.getAnimationTimeAwait(giveMeMyMoneyAct[0]);
                            $('.vertical-middle-absolute-video-preloader').delay(0)
                                .fadeOut(totalTimeAwait / 1.5);
                            AnimatedForm.showAct(giveMeMyMoneyAct, 4);
                            playFingerAct[playFingerAct.length - 1].style.setProperty('visibility', 'hidden');
                            
                            setTimeout(() => {
                                giveMeMyMoneyAct[giveMeMyMoneyAct.length - 1].style.setProperty('visibility', 'hidden');
                            }, totalTimeAwait);
                        }
                    });
                }, {once: true});
            }, {once: true});
        }, totalTimeAwait - 100);
    }

    public static spritesResizeAndPosingForm() {
        const $animatedForms = $('.container__animated-form');
        const $animatedFormsPreview = $('.container__animated-form--preview');
        const yScale = window.innerHeight / 1080 - 0.04;
        let offsetX = (window.innerWidth - 1920 * yScale) / 2;
        
        offsetX = (offsetX > 0) ? offsetX : parseInt($animatedForms.css('left'));
        $animatedForms.css({
            transform: `scale(${yScale}, ${yScale})`,
            left: offsetX
        });

        $animatedFormsPreview.css({
            transform: `scale(${yScale}, ${yScale})`,
            left: offsetX
        });
        
        const $registrationForm = $('.vertical-middle-absolute-video-preloader');
        $registrationForm.css({
            top: `${620 * yScale}px`,
            left: `${370 * yScale + offsetX}px`,
            /* left: `20.2vw`,
               top: '55vh', */
            display: 'none'
        });

        const popUpStretch = $registrationForm.find('.popup-stretch__background');
        popUpStretch.css('visibility', 'hidden');
    }

    public static getAnimationTimeAwait(act: HTMLElement): number {
        let timeAwait: number;
        if (act.style.animationDuration.indexOf(',') + 1) {
            const durations = act.style.animationDuration.split(',');
            timeAwait = (parseFloat(durations[1]) + parseFloat(act.style.animationDelay)) * 1000;
        } else {
            timeAwait = (parseFloat(act.style.animationDuration) + parseFloat(act.style.animationDelay)) * 1000;
        }
        console.log(`time await: ${timeAwait}`);
        return timeAwait;
    }

    public static showAct(acts: Array<HTMLElement>, actOrder: number, stayAtLastAct: boolean = false) {
        let totalTimeAwait: number;
        acts[0].style.setProperty('visibility', 'visible');

        totalTimeAwait = AnimatedForm.getAnimationTimeAwait(acts[0]);
        if (acts.length == 1 && acts[0].style.animationDuration.indexOf(',') + 1) {
            acts[0].style.setProperty('animation-name', `animeteform-${actOrder}-0, animeteform-v-${actOrder}-0`);
        } else {
            acts[0].style.setProperty('animation-name', `animeteform-${actOrder}-0`);
        }

        setTimeout(()=>{
            if (acts.length > 1) {
                totalTimeAwait = this.getAnimationTimeAwait(acts[1]);
                console.log(totalTimeAwait);
                acts[1].style.setProperty('visibility', 'visible');
                acts[1].style.setProperty('animation-name', `animeteform-${actOrder}-1`);
                acts[0].style.setProperty('visibility', 'hidden');

                if (!stayAtLastAct) {
                    setTimeout(()=>{
                        acts[1].style.setProperty('visibility', 'hidden');
                    }, totalTimeAwait - 100);
                }
            }
        }, totalTimeAwait);
    }
}
